module.exports = __webpack_public_path__ + "img/allied-agent.87662ea6.png";